
    import {mapGetters} from 'vuex';

    export default {

        install(Vue, $options) {
            Vue.mixin({
                computed: {
                    ...mapGetters({
                        user: 'getAuthenticatedUser'
                    })
                },
                methods: {
                    $can(permission) {
                        let hasAccess = false;
                        if (this.$root.user.hasOwnProperty('permissions') && Array.isArray(this.$root.user.permissions.data)) {
                            this.$root.user.permissions.data.forEach(ability => {
                                if (ability.name === permission) {
                                    hasAccess = true;
                                }
                            });
                        }
                        return hasAccess;
                    },

                    $hasRole(role) {
                        let hasAccess = false;
                        if (this.$root.user.hasOwnProperty('roles') && Array.isArray(this.$root.user.roles.data)) {
                            this.user.roles.data.forEach(userRole => {
                                if (userRole.name === role) {
                                    hasAccess = true;
                                }
                            });
                        }
                        return hasAccess;
                    }
                }
            })
        }
    }
